export class ListSourceAccountsRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filters",
            "baseName": "filters",
            "type": "SourceAccountsFilterConditions",
            "format": ""
        },
        {
            "name": "sorts",
            "baseName": "sorts",
            "type": "Array<SortSourceAccountsBy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSourceAccountsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
